import { render } from "./DataAdapterSettings.vue?vue&type=template&id=2d0a362e"
import script from "./DataAdapterSettings.vue?vue&type=script&lang=js"
export * from "./DataAdapterSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/data-adapters/DataAdapterSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d0a362e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d0a362e', __exports__)) {
    api.reload('2d0a362e', __exports__)
  }
  
  module.hot.accept("./DataAdapterSettings.vue?vue&type=template&id=2d0a362e", () => {
    api.rerender('2d0a362e', render)
  })

}


export default __exports__